export default __webpack_public_path__ + "static/media/walking.01e4847a.svg";